// eslint-disable-next-line import/prefer-default-export
export const GET_WIDGET_STATS = 'investormanagement/GET_WIDGET_STATS'
export const GET_WIDGET_STATS_SUCCESS = 'investormanagement/GET_WIDGET_STATS_SUCCESS'
export const GET_WIDGET_STATS_FAILED = 'investormanagement/GET_WIDGET_STATS_FAILED'
